import { db } from "../../config/firebaseconfig"
import findHighestGroupUA from "./findHighestGroupUA";
import keys from 'mout/object/keys'

export default function fetchGroupUAsPromise (user, assessmentId, actions, selectedGroupUA, view, subtestId) {
  return new Promise((resolve, reject) => {
    actions.fetching()
    // super admin might have performance issues. Might need to change to get()
    if (user.role === 'Super Administrator') {
      db.collection('groupUA').get()
        .then((querySnapshot) => {
          let groupUAs = {}
          querySnapshot.forEach((doc) => {
            groupUAs[doc.id] = doc.data()
          })
          actions.success(groupUAs)
          resolve(groupUAs)
        })
        .catch((err) => {
          actions.error(err)
          reject(err)
        })
    } else {
      let query
      if (user.role === 'District Admin') {
        query = {key: 'district', term: user.schoolDistrict}
      } else if (user.role === 'School Admin') {
        query = {key: 'school', term: user.school}
      } else if (user.role === 'Teacher') {
        query = {key: 'teacher', term: user.id}
      }
      if (query) {
        db.collection('groupUA').where(query.key, '==', query.term).get()
          .then((querySnapshot) => {
            let groupUAs = {}
            querySnapshot.forEach((doc) => {
              groupUAs[doc.id] = doc.data()
            })
            actions.success(groupUAs)
            if (keys(groupUAs).length > 0) {
              if (!groupUAs[selectedGroupUA]) {
                const highestGUA = findHighestGroupUA(groupUAs, user.role)
                if (view !== 'report') {
                  actions.push(`?gua=${highestGUA.id}`)        
                } else {
                  actions.push(`/assessment/reports/${highestGUA.id}/${subtestId}?g=true&a=${assessmentId}`)
                }
                
              }
            }
            resolve(groupUAs) 
          })
          .catch((err) => {
            actions.error(err)
            reject(err)
          })
      } else {
        resolve({})
      }

    }
  })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/fetchGroupUAsPromise.js